import styled from "styled-components";
import { Multiselect } from "react-widgets";

export const MultiSelect = styled(Multiselect)`
  .rw-widget-input {
    background: ${(props) => props.bg || "#F8F6FE"};
    color: #47495c;
    border: 1px solid #f0eefa;
    box-shadow: none;
  }

  &.rw-state-focus .rw-widget-picker.rw-widget-input {
    box-shadow: none;
  }
`;
